import { Link, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import UserDropdown from "@/src/lib/components/app/UserDropdown";
import Icon from "@/src/lib/components/custom/Icon";
import { Image } from "@/src/lib/components/custom/Image";
import { Button } from "@/src/lib/components/ui/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@/src/lib/components/ui/sheet";

export default function AdminNavbar() {
	const { pathname } = useLocation();
	const { t } = useTranslation();

	return (
		<nav className="fixed top-0 h-(--navbar-height) w-full z-50 bg-background flex items-center justify-between px-4 md:px-6">
			<div className="flex items-center min-w-0 flex-1">
				<Sheet>
					<SheetTrigger asChild>
						<Button variant="ghost" size="sm" className="lg:hidden mr-3">
							<Icon name="Menu" className="w-5 h-5" />
							<span className="sr-only">{t("admin.navbar.toggle_menu")}</span>
						</Button>
					</SheetTrigger>
					<SheetContent side="left" className="w-64 sm:w-72 p-0">
						<SheetHeader className="p-6 border-b">
							<SheetTitle className="flex items-center gap-2">
								<Image
									src="/static/logo.webp"
									alt={t("admin.navbar.logo_alt")}
									className="p-4"
								/>
							</SheetTitle>
						</SheetHeader>
						<div className="flex flex-col gap-2 p-4">
							<Button
								variant={pathname === "/admin" ? "default" : "ghost"}
								className="justify-start gap-3 h-10"
								asChild
							>
								<Link to="/admin">
									<Icon name="LayoutDashboard" className="w-4 h-4" />
									{t("admin.sidebar.dashboard")}
								</Link>
							</Button>
							<Button
								variant={pathname === "/admin/orders" ? "default" : "ghost"}
								className="justify-start gap-3 h-10"
								asChild
							>
								<Link to="/admin/orders">
									<Icon name="Package" className="w-4 h-4" />
									{t("admin.sidebar.orders")}
								</Link>
							</Button>
							<Button
								variant={pathname === "/admin/menu" ? "default" : "ghost"}
								className="justify-start gap-3 h-10"
								asChild
							>
								<Link to="/admin/menu">
									<Icon name="UtensilsCrossed" className="w-4 h-4" />
									{t("admin.sidebar.menu")}
								</Link>
							</Button>
							<Button
								variant={pathname === "/admin/users" ? "default" : "ghost"}
								className="justify-start gap-3 h-10"
								asChild
							>
								<Link to="/admin/users">
									<Icon name="Users" className="w-4 h-4" />
									{t("admin.sidebar.users")}
								</Link>
							</Button>
							<Button
								variant={pathname === "/admin/admins" ? "default" : "ghost"}
								className="justify-start gap-3 h-10"
								asChild
							>
								<Link to="/admin/admins">
									<Icon name="Shield" className="w-4 h-4" />
									{t("admin.sidebar.admins")}
								</Link>
							</Button>
						</div>
					</SheetContent>
				</Sheet>

				<div className="flex items-center gap-2 min-w-0">
					<Image
						src="/static/logo.webp"
						alt={t("admin.navbar.logo_alt")}
						className="w-10 sm:w-12 md:w-16 shrink-0"
					/>
					<div className="min-w-0">
						<h3 className="text-sm sm:text-base md:text-lg font-semibold truncate">
							{t("admin.navbar.brand_name")}
						</h3>
						<p className="text-xs sm:text-sm text-primary font-medium hidden sm:block">
							{t("admin.navbar.brand_tagline")}
						</p>
					</div>
				</div>
			</div>

			<div className="flex items-center gap-3">
				<UserDropdown />
			</div>
		</nav>
	);
}
